import React, { useState, useEffect, useRef } from 'react';
import type { ActionType, ProColumns } from '@ant-design/pro-table';
import { EditableProTable } from '@ant-design/pro-table';
// import { ProFormRadio, ProFormField } from '@ant-design/pro-form';
import axios from '../../../utils/AxiosUtil';
import AsyncSwitch from '../../../components/AsycSwitch';
import {
    Button, message, Select, Input,
    // ConfigProvider, Table, Space,
} from 'antd'
import {
    axiosPostAndHint, mask, unmask,
    // queryAxios,
} from '../../../components/reqAndHint';
import { DownloadOutlined } from '@ant-design/icons';
import j2eUtil from '../../../utils/j2e';
import moment from 'moment';
import { useSelector } from 'react-redux'
import { levelObj } from '../../../utils/info';
const { Option } = Select;
const { Search } = Input;

type DataSourceType = {
    "volunteer_id": number,
    "volunteer_code": string,
    "volunteer_name": string,
    "area": string,
    "gender": string,
    "address": string,
    "phone": string,
    "remark": string,
    "volunteer_status": string,
    "id_card": string
};

/**
 * 志工列表页面
 */
export default function list() {
    const langValue = useSelector(state => state.langList.value)
    const actionRef = useRef<ActionType>();
    const [editableKeys, setEditableRowKeys] = useState<React.Key[]>([]);
    const [dataSource, setDataSource] = useState([]);
    const [area, setArea] = useState(null);
    const [keyword, setKeyword] = useState(null);
    const [updateArea, setUpdateArea] = useState(null);
    const [AreaOpt, setAreaOpt] = useState([]);

    //筛选时地区变化
    function handleAreaChange(value) {
        // console.log(`handleAreaChange ${value}`);
        setArea(value);
        actionRef.current.reload();
    }

    //编辑时地区变化
    function EditAreaChange(value) {
        // console.log(`EditAreaChange ${value}`);
        setUpdateArea(value);
    }

    //关键词查询
    const onSearch = async (value) => {
        // console.log('onSearch:', value);
        setKeyword(value);
        actionRef.current.reload();
    }

    useEffect(() => {

        getArea();

        return () => {
            setAreaOpt([]);
        }

    }, [])


    const getArea = async () => {
        let data = await axios.post('/fund/area/getAll').catch(e => {
            message.error('地区查询失败');
            return null;
        });
        // console.log('data:', data, 'type:', typeof data);
        if (data) {
            let areaData = [...data ?.data ?.data];
            setAreaOpt([...areaData]);
            setUpdateArea([...areaData]);
        }
    }


    const columns = [
        {
            title: '序号',
            en_title: 'S/N',
            ch_title: '序号',
            dataIndex: '序号',
            editable: false,
        },
        {
            title: '编号',
            ch_title: '编号',
            en_title: 'Number',
            dataIndex: 'volunteer_code',
            formItemProps: () => {
                return {
                    rules: [{ required: true, message: '志工编号不能为空' }],
                };
            },
        },
        {
            title: '姓名',
            en_title: 'name',
            ch_title: '姓名',
            dataIndex: 'volunteer_name',
        },
        {
            title: '英文全名',
            en_title: 'enFullName',
            ch_title: '英文全名',
            dataIndex: 'en_name',
            editable: false,
        },
        {
            title: '英文名',
            en_title: 'englishName',
            ch_title: '英文名',
            dataIndex: 'first_name',
            formItemProps: () => {
                return {
                    rules: [{ required: true, message: 'first name不能为空' }],
                };
            },
        },
        {
            title: '英文中名',
            en_title: 'middleName',
            ch_title: '英文中名',
            dataIndex: 'middle_name',
        },
        {
            title: '英文姓',
            en_title: 'surName',
            ch_title: '英文姓',
            dataIndex: 'surname',
            formItemProps: () => {
                return {
                    rules: [{ required: true, message: 'surname不能为空' }],
                };
            },
        },
        {
            title: '性别',
            en_title: 'gender',
            ch_title: '性别',
            dataIndex: 'gender',
            valueType: 'select',
            valueEnum: {
                '男': {
                    text: '男',
                },
                '女': {
                    text: '女',
                },
            },
        }, {
            title: '身份',
            en_title: 'Identity',
            ch_title: '身份',
            dataIndex: 'level',
        },
        {
            title: '地区',
            en_title: 'Region',
            ch_title: '地区',
            dataIndex: 'area',
            // valueType: 'select',
            // renderFormItem: () => (
            //     <Select
            //         placeholder={langValue==0?'请选择地区(Please select region)：':(langValue==1?'请选择地区：':'Please select region:')}
            //         style={{ width: 300 }}
            //         onChange={EditAreaChange}
            //         // defaultValue={null}
            //         showSearch
            //         defaultActiveFirstOption
            //         optionFilterProp="children"
            //         filterOption={(input, option) =>
            //             option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            //         }
            //     >
            //         {AreaOpt.map(a => (
            //             <Option value={a.areaCode} key={a.areaCode}>{a.area}</Option>
            //         ))}
            //     </Select>
            // ),
            formItemProps: {
                rules: [
                    {
                        required: true, message: '请选择地区',
                    },],
            },
        },
        {
            title: '地址',
            en_title: 'address',
            ch_title: '地址',
            dataIndex: 'address',
        },
        {
            title: '电话',
            en_title: 'phone',
            ch_title: '电话',
            dataIndex: 'phone',
        },
        {
            title: '备注',
            en_title: 'remark',
            ch_title: '备注',
            dataIndex: 'remark',
        },
        {
            title: '状态',
            en_title: 'Status',
            ch_title: '状态',
            dataIndex: 'volunteer_status',
            editable: false,
            render: (text, record, _, action) => {
                let checked = record['volunteer_status'] == 'on';
                let rcd = record;

                function handleSwitchClick(checked, record) {
                    return new Promise((resolve, reject) => {
                        axios.post('/fund/volunteer/updateStatus', { volunteerId: record['volunteer_id'], volunteerStatus: checked ? "on" : "off" })
                            .then((data) => {
                                // console.log('*********axios data:', data);
                                record['状态'] = checked ? "on" : "off";
                                message.destroy();
                                message.info("更新志工状态成功");
                                actionRef.current.reload();
                                resolve(checked);
                            }).catch(e => {
                                //组件应及时恢复原状态,和成功相反，逆向操作
                                // console.log('*********axios e:', e, e.response.data);
                                record['状态'] = !checked ? "on" : "off"; "on";
                                message.destroy();
                                message.error("更新志工状态失败：" + e ?.response ?.data ?.msg);
                                reject(!checked);
                            });
                    })
                }

                return (<div>
                    <AsyncSwitch checked={checked} handleClick={
                        (checked) => handleSwitchClick(checked, rcd)
                    } />
                </div>);
            }
        },
        {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            width: '90px',
            render: (text, record, _, action) => [
                <a
                    key="editable"
                    onClick={() => {
                        // console.log('编辑：', record);
                        // console.log('startEditable:', record['volunteer_id']);
                        action ?.startEditable ?.(record['volunteer_id']);
                    }}
                >
                    {langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}
                </a>,
            ],
        },
    ];


    //志工列表下载功能 将当前数据转化为excel
    const handleDownload = () => {
        mask()
        // console.log('dataSource:', dataSource);
        // console.log('keyword:', keyword);
        // console.log('area:', area);

        try {
            //excel
            let excelData = [];
            //表头
            let title = ['编号', '姓名', '英文名', '性别', '身份', '地区', '地址', '电话', '证件号', '备注'];
            let title2 = ['dataIndex', 'name', 'gender', 'Identity', 'area', 'address', 'Telephone No.', 'ID Number', 'Remarks']
            if (langValue == 2) {
                excelData.push(title2)
            } else {
                excelData.push(title)
            }
            //数据
            dataSource.forEach(e => {
                var level = langValue == 0 ? e.ch_level : (langValue = 1 ? e.ch_level : e.en_level)
                let row = [
                    e.volunteer_code,
                    e.volunteer_name,
                    e.en_name,
                    e.gender,
                    level,
                    e.area,
                    e.address,
                    e.phone,
                    e.id_card,
                    e.remark,
                ];
                //下载列表仅包含未停用志工
                if ('on' == e.volunteer_status) {
                    excelData.push(row);
                }
            })
            //文件名
            let areaName = area || '';
            let date = moment().format('YYYYMMDD');
            let fileName = date + (langValue == 2 ? 'Volunteer info ' : '志工信息 ') + areaName + '.xlsx';

            j2eUtil.j2e(excelData, fileName);


            unmask();
            message.destroy();
            message.info(langValue == 0 ? <>请在浏览器下方查看文件，并等待下载完成<br />Please view the file below the browser and wait for the download to complete</> : (langValue == 1 ? '请在浏览器下方查看文件，并等待下载完成' : 'Please view the file below the browser and wait for the download to complete'), 10);

        } catch (error) {
            unmask();
            // console.log('handleDownload:', error);
            Modal.error({ title: langValue == 0 ? '出错了Error' : (langValue == 1 ? '出错了' : 'Error') })
        }
    }
    const getColumns = (col) => {
        let newCol = [...col];
        newCol.forEach((c, i) => {
            c.title = langValue == 0 ? <>{c.ch_title}<br />{c.en_title}</> : (langValue == 1 ? c.ch_title : c.en_title)
            if (c.dataIndex == 'level') {
                c.render = (_, item) => {
                    return langValue == 0 ? <span>{item.ch_level}<br />{item.en_level}</span> : (langValue == 1 ? item.ch_level : item.en_level)
                }
                c.renderFormItem = (_, record) => {
                    return (
                        <Select defaultValue={record.level} placeholder={langValue == 0 ? '请选择Please select' : (langValue == 1 ? '请选择' : 'Please select')} >
                            {levelObj.map((item, index) => {
                                return (
                                    <Option value={index} key={index}>{langValue == 0 ? (item.label + item.en_label) : (langValue == 1 ? item.label : item.en_label)}</Option>
                                )
                            })}
                        </Select>
                    )
                }
            }
            if (c.dataIndex == 'area') {
                // c.render = (_, item) => {
                //     return <span>{item.area}</span>
                // }
                c.renderFormItem = (_, record) => {
                    return (
                        <Select defaultValue={record.areaName} dropdownMatchSelectWidth={false} showSearch optionFilterProp="children"
                            placeholder={langValue == 0 ? '请选择Please select' : (langValue == 1 ? '请选择' : 'Please select')} >
                            {AreaOpt.map((item, index) => {
                                return (
                                    <Option value={item.areaCode + '---' + item.areaName} key={index}>{item.areaName}</Option>
                                )
                            })}
                        </Select>
                    )
                }
            }
        })
        return newCol
    }
    return (
        <div>

            <div className="input-wrapper" style={{ marginBottom: 20 }}>
                <Select dropdownMatchSelectWidth={false}
                    placeholder={langValue == 0 ? '请选择地区(Please select region)：' : (langValue == 1 ? '请选择地区：' : 'Please select region:')}
                    style={{ width: 240 }}
                    onChange={handleAreaChange}
                    // defaultValue={null}
                    showSearch
                    defaultActiveFirstOption
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                // filterSort={(optionA, optionB) =>
                //     optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                // }
                >
                    <Option value={null}>全部地区</Option>
                    {AreaOpt.map(a => (
                        <Option value={a.areaCode} key={a.areaCode}>{a.areaName}</Option>
                    ))}

                </Select>

                <Search
                    style={{ width: 200, marginLeft: 12 }}
                    className='search'
                    placeholder={langValue == 0 ? '输入关键词搜索Enter Keywords to Search' : (langValue == 1 ? '输入关键词搜索' : 'Enter Keywords to Search')}
                    allowClear
                    onSearch={onSearch}
                />

                <Button type='primary' icon={<DownloadOutlined />}
                    style={{ marginLeft: '50%' }}
                    onClick={handleDownload} >
                    {langValue == 0 ? '下载Download' : (langValue == 1 ? '下载' : 'Download')}
                </Button>

            </div>

            <EditableProTable
                rowKey="volunteer_id"
                headerTitle=""
                actionRef={actionRef}
                maxLength={5}
                scroll={{
                    x: 960,
                }}
                recordCreatorProps={false}
                loading={false}
                columnEmptyText=''//空值时不显示'-',显示空字符串
                columns={getColumns(columns)}
                request={async () => {
                    // console.log('req area:', area)
                    mask();
                    const data = await axios.post('/fund/volunteer/list', { area, keyword });

                    // console.log('volunteer/list:', data?.data?.data);

                    let dataSrc = [];

                    if (data ?.data ?.data) {
                        dataSrc = [...data ?.data ?.data];
                        dataSrc.forEach((d, i) => {
                            d['序号'] = i + 1
                            d.ch_level = levelObj[d.level].label
                            d.en_level = levelObj[d.level].en_label
                        });
                    }

                    unmask();
                    return {
                        data: dataSrc,
                        success: true,
                        total: dataSrc.length || 0,
                    }
                }}
                value={dataSource}
                onChange={
                    (dataSrc) => {
                        // console.log('epTable onChange dataSrc:', dataSrc);
                        //重新生成序号
                        dataSrc.forEach((d, i) => {
                            d['序号'] = i + 1 + "";
                        })
                        setDataSource(dataSrc);
                    }}
                pagination={{
                    pageSizeOptions: [10, 20, 50, 100, 1000],
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0
                }}
                editable={{
                    type: 'single',//一次只编辑一行，else multiple
                    editableKeys: editableKeys,//使用（EditableProTable）rowKey 的配置
                    onlyOneLineEditorAlertMessage: '序号为' + editableKeys[0] + '的数据正在编辑，请先保存该行',
                    actionRender: (row, config, dom) => [dom.save, dom.cancel],
                    onSave: async (rowKey, data, row) => {
                        console.log("onSave:", data);
                        console.log('row:', row)
                        let { area } = data;
                        if (area.includes('---')) {
                            let ai = area.split('---');
                            data.area_code = ai[0];
                            data.area = ai[1];
                        }
                        // console.log("onSave:", row);
                        //分割地区和地区编号，列表显示 地区-编号，存入MySQL的仅为编号
                        // let areaArr = data.area.split('-');
                        // console.log('areaArr:', areaArr);
                        let { first_name: firstName, middle_name: middleName, surname: surName } = data;
                        let en_name = firstName ?.trim() + (middleName ? ` ${middleName.trim()}` : '') + ` ${surName}`;
                        //更新
                        axiosPostAndHint('/volunteer/update',
                            {
                                "volunteerId": data.volunteer_id,
                                "volunteerName": data.volunteer_name,
                                "volunteerCode": data.volunteer_code,
                                "gender": data.gender,
                                "area": data.area_code,
                                "address": data.address,
                                "phone": data.phone,
                                "remark": data.remark,
                                'level': data.level,
                                'firstName': data.first_name,
                                'middleName': data.middle_name,
                                'surName': data.surname,
                                'en_name': en_name,
                            }, () => {
                                document.getElementById('/view/volunteer/list') ?.click();
                                actionRef.current.reload();
                            }, () => {
                                actionRef.current.reload();
                            }, null);
                    },
                    onChange: (editableKeys, editableRows) => {
                        // console.log("onchange editableKeys:", editableKeys, typeof editableKeys[0]);
                        // console.log("editableRows:", editableRows);
                        setEditableRowKeys(editableKeys);
                    },

                }}
            />

        </div >
    )
}
